import React from 'react';

export const PickerWithDetailsActions = ({ children }) => {
  return (
    <div className="picker-with-details__actions">
      {children}
    </div>
  )
}